angular.module('am4')
.controller('translationsListController', [
    '$scope', 'config',
    function($scope, config) {
        $scope.langs = config.languages;
    }
]);



// WEBPACK FOOTER //
// ./src/app/controllers/translationsList.js